import {Component, OnInit} from '@angular/core';
import {ContactMethodResponse} from "../../../models/Common/contactMethodResponse";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {NgxSpinnerService} from "ngx-spinner";
import {OrganizationService} from "../../../services/organization.service";
import {CommonService} from "../../../services/common.service";
import {ActivatedRoute, Router} from "@angular/router";
import swal from "sweetalert2";
import {CurrencyResponse} from "../../../models/Common/currencyResponse";
import {createPaymentForm} from "../../../helper/payment-form-helper";

@Component({
  selector: 'app-payment-info',
  templateUrl: './payment-info.component.html',
  styleUrls: ['./payment-info.component.scss']
})
export class PaymentInfoComponent implements OnInit {

  contactMethods: ContactMethodResponse[] = [];

  paymentInfoForm: FormGroup = new FormGroup({
    organizationId: new FormControl('', Validators.required),
    payment: createPaymentForm(),

  });
  currency: CurrencyResponse[] = [];

  constructor(private spinner: NgxSpinnerService,
              private organizationService: OrganizationService,
              private commonService: CommonService,
              private route: ActivatedRoute,
              private router: Router) {
    this.route.queryParams.subscribe((params) => {
      const name = params['organizationId'];
      if (name) {
        this.paymentInfoForm.get('organizationId')?.setValue(name);
      }
    });

    this.spinner.show().then(_ => {});
    Promise.all([
      this.loadContactMethods(),
      this.loadCurrency(),
      //this.loadCountry()
    ]).finally(() => this.spinner.hide());
  }

  loadCurrency() {

    return new Promise<void>((resolve, reject) => {
      this.commonService.getCurrency().subscribe({
        next: (response) => {
          this.currency = response.item || [];
          resolve();
        },
        error: (error) => {
          console.error("Error loading currency methods", error);
          reject(error);
        }
      });
    })


  }

  async ngOnInit() {
    await this.spinner.show();
    Promise.all([
      this.loadContactMethods(),
    ]).finally(() => this.spinner.hide());
  }

  loadContactMethods() {

    return new Promise<void>((resolve, reject) => {
      this.commonService.getContactMethod().subscribe({
        next: (response) => {
          this.contactMethods = response.item || [];
          resolve();
        },
        error: (error) => {
          console.error("Error loading contact methods", error);
          reject(error);
        }
      })
    });
  }


  async onSubmit() {
    if (this.paymentInfoForm.invalid) {


      if (this.paymentInfoForm.invalid) {
        Object.keys(this.paymentInfoForm.controls).forEach(key => {
          const control = this.paymentInfoForm.get(key);
          if (control instanceof FormGroup) {
            Object.keys(control.controls).forEach(innerKey => {
              control.get(innerKey)?.markAsTouched();
            });
          } else {
            control?.markAsTouched();
          }
        });
      }

      await swal.fire({
        title: 'Form Invalid',
        html: `Please correct the invalid field.`,
        icon: 'warning',
        confirmButtonText: 'OK',
      });


    } else {
      const formData = this.paymentInfoForm.value;
      await this.spinner.show();

      this.organizationService.addPaymentInfo(formData).subscribe({
        next: async (response) => {
          await this.spinner.hide();
          if (response.result) {

            await swal.fire({
              title: 'The payment info  has been created successfully.',
              icon: 'success',
              confirmButtonText: 'OK',
            }).then(() => {
              this.router.navigate(['/organization']);
            });
          } else {
            await swal.fire({
              title: response.messages?.join(','),
              icon: 'error',
              confirmButtonText: 'OK',
            });
          }
        },
        error: (error) => {
          this.spinner.hide();
          console.error("Error occurred while creating organization", error);
        }
      });
    }
  }

  getInvalidFields(form: FormGroup): string[] {
    const invalidFields: string[] = [];
    Object.keys(form.controls).forEach(key => {
      const control = form.get(key);
      if (control instanceof FormGroup) {
        invalidFields.push(...this.getInvalidFields(control));
      } else if (control && control.invalid) {
        invalidFields.push(key);
      }
    });
    return invalidFields;
  }

  formABAChange() {
    const iban = <FormControl>this.paymentInfoForm.get('payment.iban');
    const aba = <FormControl>this.paymentInfoForm.get('payment.aba');
    if (aba.value) {
      iban.clearValidators();
    }
    else {
      iban.setValidators([Validators.required]);
    }
    iban.updateValueAndValidity();
  }

  formIBANChange() {
    const iban = <FormControl>this.paymentInfoForm.get('payment.iban');
    const aba = <FormControl>this.paymentInfoForm.get('payment.aba');
    if (iban.value) {
      aba.clearValidators();
    }
    else {
      aba.setValidators([Validators.required]);
    }
    aba.updateValueAndValidity();
  }
}
